import Map from "./Map"

const Benefits = () => {
    return (
        <div className="md:mt-28 mt-16 container">
            <div className="relative z-50 sm:space-y-5 space-y-2.5 text-center md:mb-20 mb-12">
                <div className="bg-secondary/10 text-secondary py-1 sm:px-4 px-2.5 w-fit mx-auto rounded-full sm:text-base text-sm">Benefits</div>
                <h1>
                    <span className="md:text-4xl sm:text-3xl text-2xl max-w-[370px] font-semibold mx-auto">Our Customers At <span className="text-primary">Nile</span><span className="text-secondary">Wise</span></span>
                </h1>
                <p className="max-w-[764px] mx-auto sm:text-base text-sm text-textSecondary">
                    Take the next step in your career and gain the skills you need to succeed. Our courses are designed to empower you with practical knowledge and real-world expertise. Join us and start your journey today!
                </p>
            </div>
            <Map/>
            <div className="sm:mt-16 mt-12 flex justify-center sm:flex-row flex-col sm:gap-16 gap-5">
            <div className="text-center lg:col-span-1 sm:col-span-2">
                <h1 className="text-textPrimary font-semibold text-xl mb-2">Support</h1>
                <p className="text-primary mb-3">Our friendly team is here to help.</p>
                <h2 className="text-secondary font-semibold">info@nilewisect.com</h2>
            </div>
            {/* <div className="text-center lg:col-span-1 sm:col-span-2">
                <h1 className="text-textPrimary font-semibold text-xl mb-2">Sales</h1>
                <p className="text-primary mb-3">Questions or queries? Get in touch!</p>
                <h2 className="text-secondary font-semibold">sales@nilewisect.com</h2>
            </div> */}
            <div className="text-center lg:col-span-1 sm:col-span-2 sm:col-start-2">
                <h1 className="text-textPrimary font-semibold text-xl mb-2">Phone</h1>
                <p className="text-primary mb-3">From Sunday to Thrusday (9.00 AM - 5.00 PM)</p>
                <h2 className="text-secondary font-semibold">+20 1070191322</h2>
            </div>

            </div>
        </div>
    )
}

export default Benefits